import { ApiException, defaultUrlBase_ } from "./client";

export class PaymentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? defaultUrlBase_;
    }

    async send_foundation_confirmation(params: { investmentName: string, amount: string, email: string, firstName: string }): Promise<{ success: boolean }> {
        const queryString = new URLSearchParams(params).toString();
        let url_ = `${this.baseUrl}/api/Campaign/send-foundation-confirmation-email?${queryString}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.process_sendFoundationConfirmation(_response);
        });
    }

    protected async process_sendFoundationConfirmation(response: Response): Promise<{ success: boolean }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }

        if (status === 200 || status === 400) {
            return response.json().then(data => {
                return {
                    success: data.success ?? false,
                };
            });
        } else {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
    }

    async validateDuplicateEmail(email: string): Promise<{ success: boolean }> {
        const queryString = new URLSearchParams({ email }).toString();
        let url_ = `${this.baseUrl}/api/Payment/validate-duplicate-email?${queryString}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            },
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.process_validateDuplicateEmail(_response);
        });
    }

    protected async process_validateDuplicateEmail(response: Response): Promise<{ success: boolean }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }

        if (status === 200 || status === 400) {
            return response.json().then(data => {
                return {
                    success: data.success ?? false,
                };
            });
        } else {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
    }

    async getPaymentMethodDetails(): Promise<{ success: boolean; data: PaymentMethod[]; message: string }> {
        let url_ = `${this.baseUrl}/api/Payment/card-payment-methods`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.process_getPaymentMethodDetails(_response);
        });
    }

    protected async process_getPaymentMethodDetails(response: Response): Promise<{ success: boolean; data: PaymentMethod[]; message: string }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }

        if (status === 200 || status === 400) {
            return response.json().then(data => {
                return {
                    success: data.success ?? false,
                    message: data.message ?? "Unknown error occurred",
                    data: data.data ?? []
                };
            });
        } else {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
    }

    async make_payment(paymentData: any): Promise<{ success: boolean; message: string }> {
        let url_ = `${this.baseUrl}/api/Payment/process-card-payment`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.makepayment_Process(_response);
        });
    }

    protected async makepayment_Process(response: Response): Promise<{ success: boolean; message: string }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }

        if (status === 200 || status === 400) {
            return response.json().then(data => {
                return {
                    success: data.success ?? false,
                    message: data.message ?? "Unknown error occurred"
                };
            });
        } else {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
    }

    async make_bank_payment(paymentData: any): Promise<{ success: boolean; message: string }> {
        let url_ = `${this.baseUrl}/api/Payment/process-bank-payment`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.make_make_bank_payment_Process(_response);
        });
    }

    protected async make_make_bank_payment_Process(response: Response): Promise<{ success: boolean; message: string }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }

        if (status === 200 || status === 400) {
            return response.json().then(data => {
                return {
                    success: data.success ?? false,
                    message: data.message ?? "Unknown error occurred"
                };
            });
        } else {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
    }

    async getPaymentSecret(paymentData:
        {
            amount: number,
            userName?: string,
            isAnonymous?: boolean,
            email?: string,
            firstName?: string,
            lastName?: string
        }
    ): Promise<{ success: boolean; data: string; }> {
        let url_ = `${this.baseUrl}/api/Payment/ach-payment-secret`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.process_getPaymentSecret(_response);
        });
    }

    protected async process_getPaymentSecret(response: Response): Promise<{ success: boolean; data: string }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        }

        if (status === 200 || status === 400) {
            return response.json().then(data => {
                return {
                    success: data.success ?? false,
                    message: data.message ?? "Unknown error occurred",
                    data: data.data ?? []
                };
            });
        } else {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
    }

}

export interface PaymentDTO {
    amount: string;
    rememberCardDetail: boolean;
    phoneNumber: string;
    card: {
        number: string,
        expMonth: number,
        expYear: number,
        cvc: string;
    };
    billingDetails: {
        country: string;
        zipCode: string;
    };
}

export interface PaymentMethod {
    id: string;
    type: string;
    brand: string;
    last4: string;
    expiryMonth: number;
    expiryYear: number;
}

function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
): never {
    throw new ApiException(message, status, response, headers, result);
}
